import React from "react";
import {
  Cog,
  Disc,
  Waves,
  CircleDot,
  Car,
  Lightbulb,
  Filter,
  Wind,
  BatteryCharging,
  Circle,
  Snowflake,
  Sparkles,
  MoveHorizontal,
  DoorOpen,
  PanelTop,
  ChevronUpCircle,
  ChevronDownCircle,
  Armchair,
  Cpu,
  Fuel,
} from "lucide-react";

export const CATEGORY_ICON_MAP = {
  engine: Cog,
  disc: Disc,
  waves: Waves,
  "circle-dot": CircleDot,
  car: Car,
  lightbulb: Lightbulb,
  filter: Filter,
  wind: Wind,
  "battery-charging": BatteryCharging,
  circle: Circle,
  snowflake: Snowflake,
  sparkles: Sparkles,
  "move-horizontal": MoveHorizontal,
  "door-open": DoorOpen,
  "panel-top": PanelTop,
  "chevron-up-circle": ChevronUpCircle,
  "chevron-down-circle": ChevronDownCircle,
  armchair: Armchair,
  cpu: Cpu,
  fuel: Fuel,
};

export const CATEGORY_ACCENTS = {
  moteur: { tint: "from-cyan-500/20 to-cyan-700/5", ring: "ring-cyan-500/30", icon: "text-cyan-300" },
  freinage: { tint: "from-red-500/20 to-red-700/5", ring: "ring-red-500/30", icon: "text-red-300" },
  "suspension-direction": { tint: "from-indigo-500/20 to-indigo-700/5", ring: "ring-indigo-500/30", icon: "text-indigo-300" },
  "embrayage-boite": { tint: "from-amber-500/20 to-amber-700/5", ring: "ring-amber-500/30", icon: "text-amber-300" },
  carrosserie: { tint: "from-sky-500/20 to-sky-700/5", ring: "ring-sky-500/30", icon: "text-sky-300" },
  eclairage: { tint: "from-yellow-500/20 to-yellow-700/5", ring: "ring-yellow-500/30", icon: "text-yellow-300" },
  filtration: { tint: "from-emerald-500/20 to-emerald-700/5", ring: "ring-emerald-500/30", icon: "text-emerald-300" },
  echappement: { tint: "from-orange-500/20 to-orange-700/5", ring: "ring-orange-500/30", icon: "text-orange-300" },
  "electricite-batterie": { tint: "from-lime-500/20 to-lime-700/5", ring: "ring-lime-500/30", icon: "text-lime-300" },
  "pneus-jantes": { tint: "from-slate-400/20 to-slate-600/5", ring: "ring-slate-400/30", icon: "text-slate-200" },
  climatisation: { tint: "from-blue-400/20 to-blue-600/5", ring: "ring-blue-400/30", icon: "text-blue-300" },
  "accessoires-habitacle": { tint: "from-fuchsia-500/20 to-fuchsia-700/5", ring: "ring-fuchsia-500/30", icon: "text-fuchsia-300" },
  "essieu-avant": { tint: "from-teal-500/20 to-teal-700/5", ring: "ring-teal-500/30", icon: "text-teal-300" },
  "essieu-arriere": { tint: "from-teal-500/20 to-teal-700/5", ring: "ring-teal-500/30", icon: "text-teal-300" },
  portes: { tint: "from-pink-500/20 to-pink-700/5", ring: "ring-pink-500/30", icon: "text-pink-300" },
  vitres: { tint: "from-sky-400/20 to-sky-600/5", ring: "ring-sky-400/30", icon: "text-sky-200" },
  "carrosserie-avant": { tint: "from-blue-500/20 to-blue-700/5", ring: "ring-blue-500/30", icon: "text-blue-300" },
  "carrosserie-arriere": { tint: "from-violet-500/20 to-violet-700/5", ring: "ring-violet-500/30", icon: "text-violet-300" },
  "habitacle-interieur": { tint: "from-rose-500/20 to-rose-700/5", ring: "ring-rose-500/30", icon: "text-rose-300" },
  electronique: { tint: "from-emerald-400/20 to-emerald-600/5", ring: "ring-emerald-400/30", icon: "text-emerald-200" },
  "melange-carburant": { tint: "from-amber-400/20 to-amber-600/5", ring: "ring-amber-400/30", icon: "text-amber-200" },
};
